let availableOptions = {
  option1: true,
  option2: true,
};

let selectedOptions = {
  option1: null,
  option2: null,
};

let ctlProduct = null;

function initProduct() {
  const container = document.getElementById('cart-complete-the-look');
  const heading = document.getElementById('ctl-heading');
  if (!container) return;

  const productId = container.dataset.productId;

  fetchRecommendedProduct(productId)
    .then(product => {
      if (!product) return;
      ctlProduct = product;

      setupShowButton();

      showSection(heading, container);
      populateProductDetails(product);
      renderVariantOptions(product);

      setupOptionClickHandlers();
      setupAddButton();
    })
    .catch(console.error);
}

function setupShowButton() {
  const showBtn = document.getElementById('ctl-show-btn');
  const wrapperBottom = document.querySelector('.ctl-options__wrapper-bottom');
  const wrapperFull = document.querySelector('.ctl-options__wrapper-full');
  const card = document.querySelector('.ctl-card');

  if (!showBtn || !ctlProduct || !ctlProduct.variants) return;

  const variants = ctlProduct.variants;

  showBtn.addEventListener('click', (e) => {
    e.preventDefault();

    if (variants.length === 1) {

      // Only one variant - ATC adds a product
      const onlyVariant = variants[0];
      if (!onlyVariant.available) {
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: onlyVariant.id,
          quantity: 1
        })
      })
        .then(res => {
          if (!res.ok) throw new Error('Error adding to Cart');
          return res.json();
        })
        .then(() => refreshCompleteTheLook())
        .catch(console.error);
    } else {
      // Multiple variants - show options
      if (wrapperBottom) wrapperBottom.classList.remove('ctl-options__wrapper--hidden');
      if (wrapperFull) wrapperFull.classList.remove('ctl-options__wrapper--hidden');
      if (showBtn) showBtn.classList.add('ctl-show-btn--hidden');
      if (card) card.setAttribute('data-toggle', 'open');
    }
  });
}


function fetchRecommendedProduct(productId) {
  return fetch(`/recommendations/products.json?product_id=${productId}&limit=1`)
    .then(res => res.json())
    .then(data => data.products?.[0] || null);
}

function showSection(heading, container) {
  heading?.classList.remove('hidden');
  container?.classList.remove('hidden');
}

function populateProductDetails(product) {
  const firstVariant = product.variants[0];
  const price = (firstVariant.price / 100).toFixed(2);

  document.getElementById('ctl-title').textContent = product.title;
  document.getElementById('ctl-price').textContent = price;
  document.getElementById('ctl-image').src = product.featured_image;
  document.getElementById('ctl-image').alt = product.title;
  document.getElementById('ctl-link').href = product.url;
}

function renderVariantOptions(product) {
  renderLabels(product);

  const option1Values = getUniqueOptions(product.variants, 'option1');
  const option2Values = getUniqueOptions(product.variants, 'option2');

  const option1Container = document.getElementById('option1-buttons');
  const option2Container = document.getElementById('option2-buttons');

  // OPTION 1
  if (option1Values.length > 0) {
    availableOptions.option1 = true;
    option1Container.innerHTML = generateOptionButtons(option1Values, 'option1');
    option1Container.parentElement.style.display = '';
  } else {
    availableOptions.option1 = false;
    option1Container.innerHTML = '';
    option1Container.parentElement.style.display = 'none';
  }

  // OPTION 2
  if (option2Values.length > 0) {
    availableOptions.option2 = true;
    option2Container.innerHTML = generateOptionButtons(option2Values, 'option2');
    option2Container.parentElement.style.display = '';
  } else {
    availableOptions.option2 = false;
    option2Container.innerHTML = '';
    option2Container.parentElement.style.display = 'none';
  }

  // Activate CTL if no options is available
  if (!availableOptions.option1 && !availableOptions.option2) {
    selectedOptions.option1 = null;
    selectedOptions.option2 = null;
    updateAddButton();
  }
}

function renderLabels(product) {
  const optionNames = product.options;

  const option1Label = document.getElementById('option1-label');
  const option2Label = document.getElementById('option2-label');

  if (option1Label && optionNames[0]) {
    option1Label.textContent = optionNames[0].name;
  }

  if (option2Label && optionNames[1]) {
    option2Label.textContent = optionNames[1].name;
  }
}

function getUniqueOptions(variants, optionKey) {
  return [...new Set(variants.map(v => v[optionKey]).filter(Boolean))];
}

function generateOptionButtons(values, optionType) {
  return values.map(val => `
    <button class="ctl-option-btn" data-${optionType}="${val}">${val}</button>
  `).join('');
}

function setupOptionClickHandlers() {
  ['option1-buttons', 'option2-buttons'].forEach(containerId => {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.addEventListener('click', (event) => {
      const btn = event.target.closest('button.ctl-option-btn');
      if (!btn) return;

      container.querySelectorAll('button.ctl-option-btn').forEach(b => b.classList.remove('ctl-option-btn--active'));
      btn.classList.add('ctl-option-btn--active');

      updateSelectedOption();
    });
  });
}

function updateSelectedOption() {
  const option1Container = document.getElementById('option1-buttons');
  const option2Container = document.getElementById('option2-buttons');

  const activeOption1 = option1Container?.querySelector('.ctl-option-btn--active');
  const activeOption2 = option2Container?.querySelector('.ctl-option-btn--active');

  if (availableOptions.option1 && activeOption1) {
    selectedOptions.option1 = activeOption1.dataset.option1;
    option1Container.dataset.selected = selectedOptions.option1;
  } else {
    selectedOptions.option1 = null;
    if (option1Container) option1Container.dataset.selected = '';
  }

  if (availableOptions.option2 && activeOption2) {
    selectedOptions.option2 = activeOption2.dataset.option2;
    option2Container.dataset.selected = selectedOptions.option2;
  } else {
    selectedOptions.option2 = null;
    if (option2Container) option2Container.dataset.selected = '';
  }

  updateAddButton();
}

function setupAddButton() {
  const addBtn = document.getElementById('ctl-add-btn');
  if (!addBtn) return;

  addBtn.addEventListener('click', (event) => {
    event.preventDefault();

    if (!ctlProduct || !ctlProduct.variants) {
      console.error('Product not found: ', ctlProduct);
      return;
    }

    const variantsData = ctlProduct.variants;
    let variantToAdd = null;

    if (!availableOptions.option1 && !availableOptions.option2) {
      variantToAdd = variantsData[0];
    } else {
      variantToAdd = variantsData.find(v =>
        (!availableOptions.option1 || v.option1 === selectedOptions.option1) &&
        (!availableOptions.option2 || v.option2 === selectedOptions.option2)
      );
    }

    if (!variantToAdd) {
      console.error('Variant not found: ', variantToAdd);
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantToAdd.id,
        quantity: 1
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Error adding to Cart');
        return res.json();
      })
      .then(data => {
        refreshCompleteTheLook();
      })
      .catch(err => {
        console.error(err);
      });
  });
}

function updateAddButton() {
  const addBtn = document.getElementById('ctl-add-btn');
  const availabilityMsg = document.getElementById('ctl-availability-msg');
  if (!addBtn) return;

  const option1Ready = !availableOptions.option1 || selectedOptions.option1 !== null;
  const option2Ready = !availableOptions.option2 || selectedOptions.option2 !== null;

  let variantToAdd = null;

  if (ctlProduct && ctlProduct.variants && option1Ready && option2Ready) {
    variantToAdd = ctlProduct.variants.find(v =>
      (!availableOptions.option1 || v.option1 === selectedOptions.option1) &&
      (!availableOptions.option2 || v.option2 === selectedOptions.option2)
    );
  }

  if (option1Ready && option2Ready) {
    addBtn.classList.remove("addBtn--init")
    if (variantToAdd && variantToAdd.available) {
      addBtn.disabled = false;
      const selectedText = [
        availableOptions.option1 ? selectedOptions.option1 : null,
        availableOptions.option2 ? selectedOptions.option2 : null
      ].filter(Boolean).join(', ');

      addBtn.textContent = 'ADD';
      if (availabilityMsg) availabilityMsg.textContent = '';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Not available';
      if (availabilityMsg) availabilityMsg.textContent = 'This variant is not available.';
    }
  } else {
    addBtn.disabled = true;
    addBtn.textContent = 'Choose variant';
    if (availabilityMsg) availabilityMsg.textContent = '';
  }
}

function refreshCompleteTheLook() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      refreshCartDrawer();
      // Old way of refreshing (may leed to dead loop (keep for debbuging in case))
      // initProduct();
    });
}

function refreshCartDrawer() {
  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then((res) => res.json())
    .then((data) => {
      const event = new CustomEvent('cartDrawerUpdate', {
        detail: data['cart-drawer'],
      });
      document.querySelector('cart-drawer')?.dispatchEvent(event);
    })
    .catch(console.error);
}

// Initialize CTL on cart drawer init
document.addEventListener('DOMContentLoaded', () => {
  initProduct();
});

// Listen when cart drawer is updated after removing product
document.addEventListener('completeTheLookUpdate', () => {
  refreshCompleteTheLook();
});

// Listen when cart drawer is updated by adding a new product
document.querySelector('cart-drawer')?.addEventListener('cartDrawerUpdate', (event) => {
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    cartDrawer.innerHTML = event.detail;

    setTimeout(() => {
      const ctlContainer = document.getElementById('cart-complete-the-look');
      if (ctlContainer) {
        initProduct();
      }
    }, 0);
  }
});